import React, { Component } from 'react';
import { AppContext, AppConsumer } from '../components/AppContext';
import withTracker from "../utils/withTracker";

class Chat extends Component {
    state = { isOpen: true, chatEnded: false };

    componentDidMount() {
        this._prevStatus = this.context.state.actualTurn.status;
    }

    componentDidUpdate() {
        const { status } = this.context.state.actualTurn;
        if (this._prevStatus === 'ANNOUNCED' && status !== 'ANNOUNCED') {
            this.setState({ chatEnded: true });
            if (this.props.onChatEnded) this.props.onChatEnded();
        }
        this._prevStatus = status;
    }

    render() {
        if (this.state.chatEnded) return null;

        const { actualTurn } = this.context.state;
        if (actualTurn.status !== 'ANNOUNCED') return null;

        const chatURL = actualTurn.jsonDetails && actualTurn.jsonDetails.chatURL;
        if (!chatURL) return null;

        const { t } = this.context;

        return (
            <div style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 1000 }}>
                {this.state.isOpen && (
                    <div style={{
                        position: 'absolute',
                        bottom: '70px',
                        right: '0',
                        width: '350px',
                        height: '500px',
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            backgroundColor: '#1a1a2e',
                            color: 'white',
                            padding: '14px 20px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexShrink: 0
                        }}>
                            <span style={{ fontWeight: '600', fontSize: '16px' }}>Chat</span>
                            <button
                                onClick={() => this.setState({ isOpen: false })}
                                style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer', fontSize: '18px', padding: 0, lineHeight: 1 }}
                            >
                                <i className="fa fa-times" />
                            </button>
                        </div>
                        <iframe
                            src={chatURL}
                            style={{ width: '100%', flex: 1, border: 'none' }}
                            title="chat"
                        />
                    </div>
                )}
                <button
                    onClick={() => this.setState(function(prev) { return { isOpen: !prev.isOpen }; })}
                    style={{
                        width: this.state.isOpen ? '56px' : 'auto',
                        height: '56px',
                        borderRadius: this.state.isOpen ? '50%' : '28px',
                        padding: this.state.isOpen ? '0' : '0 20px',
                        backgroundColor: '#7B61FF',
                        border: 'none',
                        color: 'white',
                        fontSize: '20px',
                        cursor: 'pointer',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <i className={this.state.isOpen ? 'fa fa-times' : 'fa fa-comments'} />
                    {!this.state.isOpen && <span style={{ fontSize: '13px', marginLeft: '6px', fontWeight: '600' }}>{t("Chat.OPEN_CHAT")}</span>}
                </button>
            </div>
        );
    }
}

Chat.contextType = AppContext;
export default withTracker(Chat);
